import React from 'react';

function PageWrapper({ children, title }) {
	return (
		<div className='mobile_only'>
			<div style={{ margin: 0, width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
				<div>
					<img src={require('../assets/images/alkalma_education_logo.png')} alt='AlkalmaUp' style={{ width: 'min(200px, calc(100vw - 100px))', marginTop: 30 }} className='mx-auto' />
				</div>
				<div
					style={{
						backgroundColor: 'white',
						width: 'min(1100px, calc(100vw - 50px))',
						alignSelf: 'center',
						margin: 'auto',
						marginTop: 20,
						borderRadius: '50px 50px 0 0',
						textAlign: 'left',
						flex: '1',
					}}
					className='p-6 md:p-12'
				>
					{title && <h1 className='text-[#153c4f] font-bold text-2xl md:text-[2rem] text-center mb-[40px]'>{title}</h1>}

					{children}
				</div>
			</div>
		</div>
	);
}

export default PageWrapper;
